/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Portal_Scanner_Filtered_OutInputs */

const en_portal_scanner_filtered_out = /** @type {(inputs: Portal_Scanner_Filtered_OutInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Filtered Out`)
};

const de_portal_scanner_filtered_out = /** @type {(inputs: Portal_Scanner_Filtered_OutInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Filtered Out`)
};

const fr_portal_scanner_filtered_out = /** @type {(inputs: Portal_Scanner_Filtered_OutInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Filtered Out`)
};

const es_portal_scanner_filtered_out = /** @type {(inputs: Portal_Scanner_Filtered_OutInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Filtered Out`)
};

const it_portal_scanner_filtered_out = /** @type {(inputs: Portal_Scanner_Filtered_OutInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Filtered Out`)
};

const nl_portal_scanner_filtered_out = /** @type {(inputs: Portal_Scanner_Filtered_OutInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Filtered Out`)
};

const pl_portal_scanner_filtered_out = /** @type {(inputs: Portal_Scanner_Filtered_OutInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Filtered Out`)
};

const fi_portal_scanner_filtered_out = /** @type {(inputs: Portal_Scanner_Filtered_OutInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Filtered Out`)
};

const da_portal_scanner_filtered_out = /** @type {(inputs: Portal_Scanner_Filtered_OutInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Filtered Out`)
};

const sv_portal_scanner_filtered_out = /** @type {(inputs: Portal_Scanner_Filtered_OutInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Filtered Out`)
};

/**
* | output |
* | --- |
* | "Filtered Out" |
*
* @param {Portal_Scanner_Filtered_OutInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const portal_scanner_filtered_out = /** @type {((inputs?: Portal_Scanner_Filtered_OutInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Portal_Scanner_Filtered_OutInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_portal_scanner_filtered_out(inputs)
	if (locale === "fr") return fr_portal_scanner_filtered_out(inputs)
	if (locale === "es") return es_portal_scanner_filtered_out(inputs)
	if (locale === "it") return it_portal_scanner_filtered_out(inputs)
	if (locale === "nl") return nl_portal_scanner_filtered_out(inputs)
	if (locale === "pl") return pl_portal_scanner_filtered_out(inputs)
	if (locale === "fi") return fi_portal_scanner_filtered_out(inputs)
	if (locale === "da") return da_portal_scanner_filtered_out(inputs)
	if (locale === "sv") return sv_portal_scanner_filtered_out(inputs)
	return en_portal_scanner_filtered_out(inputs)
});